export default "__VITE_ASSET__B3r4ABiR__"